import React, { useState, useEffect } from "react";
import RoiquantLogo from "../../../assets/navbar/roiquantlogo-600x200px-01.png";
import RoiquantLogo2 from "../../../assets/navbar/roiquant-48x48px-newfavicon-01.png";
import HeaderLogo from "../../../assets/navbar/roiquant-600x200px-white-01.png";
import ReactTooltip from "react-tooltip";
import { BrowserRouter as Router, Link } from "react-router-dom";
import {
  Navbar,
  Nav,
  NavDropdown,
  Accordion,
  Card,
  Spinner,
  Alert,
  Button,
  Container,
} from "react-bootstrap";
import {
  AiFillAppstore,
  AiOutlineClose,
  AiOutlineCheckCircle,
} from "react-icons/ai";
import {
  FaBell,
  FaQuestionCircle,
  FaCog,
  FaUserAlt,
  FaBars,
  FaArrowAltCircleLeft,
  FaChevronLeft,
  FaChevronDown,
} from "react-icons/fa";
import { BiAnalyse } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useSupabaseApp } from "../../SupabaseApp";
import { useHistory, useLocation } from "react-router";
import "../navbar/navbar.css";
import ApplicationButton from "../../components/capital-financing/application-button";
import PaymentModal from "./payment-modal";

/**
 * NavBar Component
 *
 * Main navigation bar component displayed at the top of the application. Provides access to
 * all primary features including dashboard, data, intelligence modules, tools, simulation, and sourcing.
 * Includes sidebar navigation with accordion-style expandable menu items. Manages alert notifications,
 * user authentication (logout), Stripe billing portal access, and dynamic CTA buttons based on current page.
 * Displays sticky navbar on scroll, user tier-based conditional rendering (e.g., borrower platform link),
 * and responsive navigation for mobile devices.
 *
 * @returns {JSX.Element} Navigation bar with top navbar, bottom navbar with logo/dashboard button, and sidebar menu
 */
const NavBar = () => {
  // Alert state for floating notifications displayed at top of navbar
  const [alert, setAlert] = useState(false);

  // Message state for alert content - can be string or JSX element for loading states
  const [message, setMessage] = useState("");

  // Closes floating alert notification and clears message content
  function closeAlert() {
    setAlert(false);
    setMessage("");
  }

  const [showPaymentModal, setShowPaymentModal] = useState(false);

  function openPaymentModal() {
    setShowPaymentModal(true);
  }

  function closePaymentModal() {
    setShowPaymentModal(false);
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.get("openPaymentModal") === "true") {
      setShowPaymentModal(true);

      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const getPricingUrl = () => {
    const { hostname } = window.location;

    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "http://localhost:3001/pricing";
    }

    const isVercelPreview =
      hostname === "landing-preview.roiquant.com" ||
      hostname === "app-preview.roiquant.com";

    if (isVercelPreview) {
      return "https://landing-preview.roiquant.com/pricing";
    }

    return "https://www.roiquant.com/pricing";
  };

  const { logOut, supabase, getUserTier } = useSupabaseApp();

  // User's subscription tier (used for conditional rendering like borrower platform link)
  const [tier, setTier] = useState();

  // Fetch user's subscription tier on component mount
  useEffect(() => {
    const checkTier = async () => {
      const tierValue = await getUserTier();
      setTier(tierValue);
    };

    checkTier();
  }, []);

  // const [billingOverview, setBillingOverview] = useState('#');

  // Render effect once
  // useEffect(() => {
  //     if (isLoggedIn()) {
  //         async function getUrl() {
  //             if (currentUser.customData.stripeCustomerId) {

  //                 try {
  //                     const url = await currentUser.functions.getMyStripeCustomerPortalLink();

  //                     if (url) {
  //                         setBillingOverview(url);
  //                     }
  //                     else {
  //                         setBillingOverview("#");
  //                     }
  //                 } catch (err) {
  //                     // console.error(err);
  //                 }
  //             }
  //         }
  //         getUrl();
  //     }
  // }, []);

  // function loadBillingOverview() {
  //     // show loading message
  //     setAlert(true);
  //     setMessage(<div style={{ display: "flex", paddingTop: "10px" }}>
  //         <div style={{ width: "90%" }}>
  //             <p style={{ color: "#0f9d58" }}><BiAnalyse className="alert-icon" /> Loading</p>
  //             <p style={{ marginLeft: "28px", fontSize: "14px" }}>Won't be long now. We're connecting to your billing customer portal.</p>
  //             <p style={{ marginLeft: "28px", fontSize: "14px" }}>If your waiting time is too long, <a href="https://www.roiquant.com/contact" target="_blank" rel="noopener noreferrer">contact us</a>.</p>
  //         </div>
  //         <div style={{ width: "10%", textAlign: "right" }}>
  //             <Spinner animation="border" variant="secondary" />
  //         </div>
  //     </div>);

  //     if (billingOverview !== "#") {
  //         // show loading message
  //         setAlert(true);
  //         setMessage(<div style={{ paddingTop: "10px" }}>
  //             <p style={{ color: "#1f5f8b" }}><AiOutlineCheckCircle className="alert-icon" /> Ready</p>
  //             <p style={{ marginLeft: "28px" }}>Your billing customer portal is ready. <Link to={billingOverview} target="_blank" rel="noopener noreferrer" className="alert-cta">View billing portal</Link></p>
  //         </div>);
  //     }
  // }

  async function openStripeTab() {
    // Show loading alert while fetching Stripe portal link
    setAlert(true);
    setMessage(
      <div style={{ display: "flex", paddingTop: "10px" }}>
        <div style={{ width: "90%" }}>
          <p style={{ color: "#0f9d58" }}>
            <BiAnalyse className="alert-icon" /> Loading
          </p>
          <p style={{ marginLeft: "28px", fontSize: "14px" }}>
            Won't be long now. We're connecting to your billing customer portal.
          </p>
          <p style={{ marginLeft: "28px", fontSize: "14px" }}>
            If your waiting time is too long,{" "}
            <a
              href="https://www.roiquant.com/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              contact us
            </a>
            .
          </p>
        </div>
        <div style={{ width: "10%", textAlign: "right" }}>
          <Spinner animation="border" variant="secondary" />
        </div>
      </div>,
    );

    let url;
    try {
      // Call Supabase edge function to generate Stripe customer portal link
      const { data, error } = await supabase.functions.invoke(
        "getMyStripeCustomerPortalLink",
        {
          body: {},
        },
      );

      if (error) {
        // Extract error message from Supabase error context
        const ctx = await error.context?.json?.().catch(() => ({}));
        const msg = ctx?.error ?? "unknown";
        throw new Error(msg);
      }

      // Store the Stripe portal URL returned from edge function
      url = data;
    } catch (error) {
      // Handle various error scenarios from Stripe API
      setAlert(true);

      // Check if error is a thrown Error object with a message property
      if (error.name === "Error") {
        if (error.message.includes("no id")) {
          setMessage(
            <div style={{ paddingTop: "10px" }}>
              <p style={{ color: "#1f5f8b" }}>
                <AiOutlineCloseCircle
                  className="alert-icon"
                  style={{ color: "#dc3545" }}
                />{" "}
                No billing history available – yet!
              </p>
              <p style={{ marginLeft: "28px" }}>
                You’re currently on our Free Plan and haven’t made any purchases
                yet, so there are no invoices or receipts to show.
              </p>
              <p style={{ marginLeft: "28px" }}>
                <a
                  href="https://www.roiquant.com/pricing"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    cursor: "pointer",
                    color: "#55a2da",
                  }}
                >
                  Check out the benefits and features
                </a>{" "}
                of our{" "}
                <span
                  style={{
                    textShadow:
                      "0.15px 0 0 currentColor, -0.15px 0 0 currentColor",
                  }}
                >
                  Premium Plan for only US$300 per year
                </span>
                . When you're ready,{" "}
                <button
                  type="button"
                  onClick={openPaymentModal}
                  style={{
                    cursor: "pointer",
                    color: "#55a2da",
                    textDecoration: "none",
                    background: "none",
                    border: "none",
                    padding: 0,
                    margin: 0,
                    font: "inherit",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  upgrade for premium features
                </button>
                .
              </p>
              <p style={{ marginLeft: "28px" }}>
                If you’re an existing customer, get ready your receipt and{" "}
                <a
                  href="https://www.roiquant.com/contact"
                  style={{
                    cursor: "pointer",
                    color: "#58a8e0",
                  }}
                >
                  contact us
                </a>
                .
              </p>
            </div>,
          );

          return;
        }
        if (error.message.includes("failed to create session")) {
          setMessage(
            <div style={{ paddingTop: "10px" }}>
              <p style={{ color: "#1f5f8b" }}>
                <AiOutlineCheckCircle className="alert-icon" /> Error
              </p>
              <p style={{ marginLeft: "28px" }}>Failed to create session</p>
            </div>,
          );
          return;
        }
        if (error.message.includes("mode not specified")) {
          setMessage(
            <div style={{ paddingTop: "10px" }}>
              <p style={{ color: "#1f5f8b" }}>
                <AiOutlineCheckCircle className="alert-icon" /> Error
              </p>
              <p style={{ marginLeft: "28px" }}>Stripe configuration error</p>
            </div>,
          );
          return;
        }
      } else {
        // Handle unexpected error types that aren't standard Error objects
        setMessage(
          <div style={{ paddingTop: "10px" }}>
            <p style={{ color: "#1f5f8b" }}>
              <AiOutlineCheckCircle className="alert-icon" /> Error
            </p>
            <p style={{ marginLeft: "28px" }}>Unhandled error</p>
          </div>,
        );
        return;
      }
    }
    closeAlert();
    // Open Stripe customer portal in new tab
    window.open(url, "_blank");
  }

  // Sidebar visibility state (open/close sidebar menu on mobile)
  const [showSidebar, setShowSidebar] = useState({ open: false });

  const history = useHistory();

  const location = useLocation();

  // Opens sidebar navigation menu
  function toggleOpen() {
    setShowSidebar({ open: true });
  }

  // Closes sidebar navigation menu
  function toggleClose() {
    setShowSidebar({ open: false });
  }

  // Arrow state for accordion menu items - tracks which sections are expanded
  const [changeArrow, setChangeArrow] = useState({
    data: false,
    shutdownData: false,
    businessData: false,
    startupIntelligence: false,
    ventureIntelligence: false,
    competitiveIntelligence: false,
    tools: false,
    foundersTools: false,
    simulation: false,
    foundersSimulation: false,
    sourcing: false,
    fundingSourcing: false,
    dealsSourcing: false,
  });

  // Toggle functions for expanding/collapsing accordion sections
  function changeData() {
    setChangeArrow({ data: !changeArrow.data });
  }

  function changeShutdownData() {
    setChangeArrow({ shutdownData: !changeArrow.shutdownData, data: true });
  }

  function changeBusinessData() {
    setChangeArrow({ businessData: !changeArrow.businessData, data: true });
  }

  function changeStartupIntelligence() {
    setChangeArrow({ startupIntelligence: !changeArrow.startupIntelligence });
  }

  function changeVentureIntelligence() {
    setChangeArrow({ ventureIntelligence: !changeArrow.ventureIntelligence });
  }

  function changeCompetitiveIntelligence() {
    setChangeArrow({
      competitiveIntelligence: !changeArrow.competitiveIntelligence,
    });
  }

  function changeTools() {
    setChangeArrow({ tools: !changeArrow.tools });
  }

  function changeFoundersTools() {
    setChangeArrow({ foundersTools: !changeArrow.foundersTools, tools: true });
  }

  function changeSimulation() {
    setChangeArrow({ simulation: !changeArrow.simulation });
  }

  function changeFoundersSimulation() {
    setChangeArrow({
      foundersSimulation: !changeArrow.foundersSimulation,
      simulation: true,
    });
  }

  function changeSourcing() {
    setChangeArrow({ sourcing: !changeArrow.sourcing });
  }

  function changeFundingSourcing() {
    setChangeArrow({
      fundingSourcing: !changeArrow.fundingSourcing,
      sourcing: true,
    });
  }

  function changeDealsSourcing() {
    setChangeArrow({
      dealsSourcing: !changeArrow.dealsSourcing,
      sourcing: true,
    });
  }

  // Logout handler - logs out user and refreshes page
  async function handleLogOut() {
    await logOut();
    history.go(0);
  }

  // Track scroll position to apply sticky navbar styling on scroll
  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY === 0) {
        setScroll(false);
      } else {
        setScroll(true);
      }
    });
  }, []);

  return (
    <div>
      {/* Floating alert notification displayed at top of navbar */}
      {alert ? (
        <Alert className="error-message floating-alert" variant="light">
          <div>
            <div style={{ textAlign: "right" }}>
              <Button className="pitchdeckmessageclose" onClick={closeAlert}>
                <IoMdClose />
              </Button>
            </div>
            {message}
          </div>
        </Alert>
      ) : (
        ""
      )}

      {/* Sidebar navigation menu - shown when showSidebar.open is true */}
      <div style={{ display: showSidebar.open ? "block" : "none" }}>
        <div id="sidebarcont">
          <div className="sidebarclose">
            <button className="sidebarbutton" onClick={toggleClose}>
              <AiOutlineClose />
            </button>
          </div>

          <div className="sidebarhead">
            <a
              href="https://www.roiquant.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={HeaderLogo} alt="roiquant" className="sidebarlogo" />
            </a>
          </div>

          <div className="sidebarback">
            <FaArrowAltCircleLeft className="sidebarbackicon" />
            <a
              href="https://www.roiquant.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Back to roiquant.com
            </a>
          </div>

          {/* Accordion navigation with expandable menu sections */}
          <Accordion>
            <Accordion.Item eventKey="0" className="sidebarheader">
              <Accordion.Header>
                {/* Display chevron icon based on expanded state */}
                {changeArrow.data ? (
                  <FaChevronDown className="sidebarheaderarrow" />
                ) : (
                  <FaChevronLeft className="sidebarheaderarrow" />
                )}{" "}
                <span className="sidebartab">Data</span>
              </Accordion.Header>
              <Accordion.Body className="sidebarcardbody">
                {/* SHUTDOWN DATA section with data about failed/closed companies */}
                <p>SHUTDOWN DATA </p>
                <a href="/data/shuttered-companies">Shuttered companies</a>
                <p></p>
                <a href="/data/investors-losses">Investors' losses</a>
                <p></p>
                <a href="/data/discontinued-products">Discontinued products</a>

                <hr />

                {/* COMMERCIAL DATA section with active company data */}
                <p>COMMERCIAL DATA </p>
                <a href="/data/companies">Active companies</a>
                <p></p>
                <a href="/data/product-showcase">Products showcase</a>
                <p></p>
                <a href="/data/data-room">Data room</a>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="sidebarheader">
              <Accordion.Header>
                {changeArrow.startupIntelligence ? (
                  <FaChevronDown className="sidebarheaderarrow" />
                ) : (
                  <FaChevronLeft className="sidebarheaderarrow" />
                )}{" "}
                <span className="sidebartab">Startup Intelligence</span>
              </Accordion.Header>
              <Accordion.Body className="sidebarcardbody">
                <a href="/startup-intel/postmortem-analysis">
                  Postmortem analysis{" "}
                </a>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="sidebarheader">
              <Accordion.Header>
                {changeArrow.ventureIntelligence ? (
                  <FaChevronDown className="sidebarheaderarrow" />
                ) : (
                  <FaChevronLeft className="sidebarheaderarrow" />
                )}{" "}
                <span className="sidebartab">Venture Intelligence</span>
              </Accordion.Header>
              <Accordion.Body className="sidebarcardbody">
                <a href="/venture-intel/portfolio-analysis">
                  Portfolio analysis{" "}
                </a>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className="sidebarheader">
              <Accordion.Header>
                {changeArrow.competitiveIntelligence ? (
                  <FaChevronDown className="sidebarheaderarrow" />
                ) : (
                  <FaChevronLeft className="sidebarheaderarrow" />
                )}{" "}
                <span className="sidebartab">Competitive Intelligence</span>
              </Accordion.Header>
              <Accordion.Body className="sidebarcardbody">
                <a href="#" className="sidebarinactive">
                  Competitive landscape{" "}
                  <span className="sidebarstillbuildinglabel">
                    Available soon
                  </span>
                </a>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4" className="sidebarheader">
              <Accordion.Header>
                {changeArrow.tools ? (
                  <FaChevronDown className="sidebarheaderarrow" />
                ) : (
                  <FaChevronLeft className="sidebarheaderarrow" />
                )}{" "}
                <span className="sidebartab">Tools</span>
              </Accordion.Header>
              <Accordion.Body className="sidebarcardbody">
                {/* FOR FOUNDERS section - tools still in development */}
                <p>FOR FOUNDERS </p>
                <a href="#" className="sidebarinactive">
                  Idea validation
                </a>{" "}
                <span className="sidebarstillbuildinglabel">
                  Under maintenance
                </span>
                <p></p>
                <a href="/tools/founders/business-plan">
                  Business plan builder{" "}
                </a>
                <p></p>
                {/* <a href="#" className="sidebarinactive">
                  No-code web builder
                </a> */}
              </Accordion.Body>
            </Accordion.Item>

            {/* Simulation accordion section - pre-revenue valuation, market sizing, VC benchmarks */}
            <Accordion.Item eventKey="5" className="sidebarheader">
              <Accordion.Header>
                {changeArrow.simulation ? (
                  <FaChevronDown className="sidebarheaderarrow" />
                ) : (
                  <FaChevronLeft className="sidebarheaderarrow" />
                )}{" "}
                <span className="sidebartab">Simulation</span>
              </Accordion.Header>
              <Accordion.Body className="sidebarcardbody">
                <p>FOR FOUNDERS</p>
                <a href="/simulation/founders/pre-revenue-valuation">
                  Pre-revenue business valuation{" "}
                </a>
                <p></p>
                <a href="/simulation/founders/market-sizing">Market sizing </a>
                <p></p>
                <a href="/simulation/founders/vc-funding-benchmarks">
                  VC funding benchmarks{" "}
                  <span className="sidebarbetalabel">Beta</span>
                </a>
              </Accordion.Body>
            </Accordion.Item>

            {/* Sourcing accordion section - funding stage filters */}
            <Accordion.Item eventKey="6" className="sidebarheader">
              <Accordion.Header>
                {changeArrow.sourcing ? (
                  <FaChevronDown className="sidebarheaderarrow" />
                ) : (
                  <FaChevronLeft className="sidebarheaderarrow" />
                )}{" "}
                <span className="sidebartab">Sourcing</span>
              </Accordion.Header>
              <Accordion.Body className="sidebarcardbody">
                {/* FUNDING subsection with stage-specific sourcing links */}
                <p>FUNDING </p>
                <a href="/sourcing/funding/very-early-stage">
                  Very-early stage
                </a>
                <p></p>
                <a href="/sourcing/funding/early-stage">Early stage</a>
                <p></p>
                <a href="/sourcing/funding/growth-stage">Growth stage</a>
                <p></p>
                <a href="/sourcing/funding/late-stage">Late stage</a>
                <p></p>
                <a href="/sourcing/funding/post-ipo-stage">Post-IPO stage</a>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div>
        <Router>
          {/* Top navbar with links to pricing, apps, notifications, support, and settings */}
          <Navbar
            id="navbarcomponent"
            className={scroll ? "navbartopsticky" : "navbartop"}
            bg="white"
            variant="grey"
            fluid="true"
          >
            <Container>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <ReactTooltip
                  className="navbartooltip"
                  place="bottom"
                  type="dark"
                  effect="solid"
                />

                <div className="navbarslogan">
                  <span>
                    <i>Helping entrepreneurs grow and raise financing</i>
                  </span>
                </div>

                {/* CTA Link to pricing page */}
                <Nav.Link
                  onClick={openPaymentModal}
                  className="glintanimation navbardashboard"
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  data-tip="Upgrade for premium features"
                >
                  Upgrade
                </Nav.Link>

                <PaymentModal
                  show={showPaymentModal}
                  onHide={closePaymentModal}
                  plan="pro"
                  annualSelected={true}
                  onChooseAnnually={() => {}}
                />

                {/* Apps dropdown - shows borrower platform link only for tier 3+ users */}
                <NavDropdown
                  align="end"
                  className="navbardropdown"
                  title={<AiFillAppstore className="navbaricon" />}
                  id="basic-nav-dropdown"
                  data-tip="Apps"
                >
                  {tier >= 3 ? (
                    <NavDropdown.Item
                      className="navbardropdownitem"
                      id="navbaractive"
                      href="/borrower-platform"
                    >
                      Borrower Login
                    </NavDropdown.Item>
                  ) : (
                    ""
                  )}
                  {/* <NavDropdown.Item className="navbardropdownitem" id="navbaractive" href="https://competition.roiquant.com/" target="_blank" rel="noopener noreferrer">Startup Competition</NavDropdown.Item>
                                <NavDropdown.Item className="navbardropdownitem" id="navbaractive" href="/referral-program">Referral Program</NavDropdown.Item>
                                <NavDropdown.Item className="navbardropdownitem">Integrated Apps</NavDropdown.Item> */}
                </NavDropdown>

                <Nav.Link data-tip="Notifications">
                  <FaBell className="navbaricon" />
                </Nav.Link>

                {/* Support dropdown with links to FAQ, policies, and help */}
                <NavDropdown
                  align="end"
                  className="navbardropdown"
                  title={<FaQuestionCircle className="navbaricon" />}
                  id="basic-nav-dropdown"
                  data-tip="Support"
                >
                  {/* <NavDropdown.Item className="navbardropdownitem" id="navbaractive" href="https://viewpoints.roiquant.com/tutorials/" target="_blank" rel="noopener noreferrer">Tutorials</NavDropdown.Item> */}
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="https://viewpoints.roiquant.com/frequently-asked-questions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Frequently Asked Questions
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="https://viewpoints.roiquant.com/citation-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Citation Policy
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="https://viewpoints.roiquant.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="https://viewpoints.roiquant.com/terms-of-service/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms of Service
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="https://viewpoints.roiquant.com/whats-new"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    What's New
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="https://www.roiquant.com/contact"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Need More Help
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="https://www.roiquant.com/about"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    About roiquant
                  </NavDropdown.Item>
                </NavDropdown>

                {/* Settings dropdown with billing portal, password reset, and logout */}
                <NavDropdown
                  align="end"
                  className="navbardropdown"
                  title={<FaCog className="navbaricon" />}
                  id="basic-nav-dropdown"
                  data-tip="Settings"
                >
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    onClick={openStripeTab}
                  >
                    Billing Portal
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    href="/reset-password"
                  >
                    Change password
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    className="navbardropdownitem"
                    id="navbaractive"
                    onClick={handleLogOut}
                    style={{ textAlign: "center" }}
                  >
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>

                {/* <NavDropdown align="end" className="navbardropdown" title={<FaUserAlt className="navbaricon" />} id="basic-nav-dropdown" data-tip="Account">
                                <NavDropdown.Item className="navbardropdownitem" id="navbaractive" href="/profile">Account</NavDropdown.Item>
                                <NavDropdown.Item className="navbardropdownitem" id="navbaractive" href="/profile-management">Profile management</NavDropdown.Item>
                            </NavDropdown> */}
              </Navbar.Collapse>
            </Container>
          </Navbar>

          {/* Bottom navbar with logo, dashboard button, and dynamic CTA based on current page */}
          <Navbar
            bg="white"
            variant="grey"
            fluid="true"
            className={scroll ? "navbarbottomsticky" : "navbarbottom"}
          >
            <Container>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav.Link style={{ marginLeft: "-7px" }} data-tip="Menu">
                  <button onClick={toggleOpen} className="sidebarbutton">
                    <FaBars className="navbaricon" />
                  </button>
                </Nav.Link>

                <Nav.Link href="/dashboard" data-tip="Dashboard">
                  <button className="glintanimation navbardashboard">
                    Dashboard
                  </button>
                </Nav.Link>

                <div className="navbarlogodiv">
                  <a
                    href="https://www.roiquant.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="navbarlogo"
                      src={RoiquantLogo}
                      alt="roiquant"
                    />
                    <img
                      className="navbarlogo2"
                      src={RoiquantLogo2}
                      alt="roiquant"
                    />
                  </a>
                </div>

                {/* Dynamic CTA button based on current page location - shows "Apply for financing", "Add new", or nothing */}
                {/* Dashboard/home pages show 'Apply for financing' button */}
                {location.pathname === "/dashboard" ||
                location.pathname === "/" ? (
                  <Nav.Link href="/capital-financing">
                    <button className="glintanimation navbarideachecker">
                      Apply for financing
                    </button>
                  </Nav.Link>
                ) : location.pathname.includes("/data") ||
                  location.pathname.includes("/sourcing/funding") ? (
                  // Disable "Add new" button on data and sourcing pages
                  <Nav.Link
                    href="#"
                    style={{
                      color: "#575757ff",
                      pointerEvents: "none",
                      opacity: 0.65,
                      textDecoration: "none",
                      cursor: "not-allowed",
                    }}
                  >
                    <button
                      className="glintanimation navbaraddnew"
                      disabled
                      style={{
                        backgroundColor: "#ccc",
                        color: "#666",
                        cursor: "not-allowed",
                      }}
                    >
                      Add new
                    </button>
                  </Nav.Link>
                ) : location.pathname === "/capital-financing" ? (
                  // Capital financing page shows ApplicationButton component
                  <ApplicationButton title="Apply for financing" />
                ) : (
                  // Other pages show no CTA button
                  ""
                )}
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </Router>
      </div>
    </div>
  );
};

export default NavBar;
